exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wpgp-settings-header .loader {\n  float: right; }\n", ""]);
